import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
});

// --- Crop Types ---
export const getCropTypes = async () => {
    const response = await axios.get(`${apiUrl}/crop-types`, { headers: getAuthHeaders() });
    return response.data;
};

export const createCropType = async (data) => {
    const response = await axios.post(`${apiUrl}/crop-types`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const updateCropType = async (id, data) => {
    const response = await axios.put(`${apiUrl}/crop-types/${id}`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const deleteCropType = async (id) => {
    const response = await axios.delete(`${apiUrl}/crop-types/${id}`, { headers: getAuthHeaders() });
    return response.data;
};

// --- Varieties ---
export const getVarieties = async () => {
    const response = await axios.get(`${apiUrl}/varieties`, { headers: getAuthHeaders() });
    return response.data;
};

export const createVariety = async (data) => {
    const response = await axios.post(`${apiUrl}/varieties`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const updateVariety = async (id, data) => {
    const response = await axios.put(`${apiUrl}/varieties/${id}`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const deleteVariety = async (id) => {
    const response = await axios.delete(`${apiUrl}/varieties/${id}`, { headers: getAuthHeaders() });
    return response.data;
};

export const getVarietiesByCropType = async (cropTypeId) => {
    const response = await axios.get(`${apiUrl}/varieties/by-crop-type/${cropTypeId}`, { headers: getAuthHeaders() });
    return response.data;
};

// --- Growth Phases ---
export const getGrowthPhasesByVariety = async (varietyId) => {
    const response = await axios.get(`${apiUrl}/growth-phases/by-variety/${varietyId}`, { headers: getAuthHeaders() });
    return response.data;
};

export const createGrowthPhase = async (varietyId, data) => {
    const response = await axios.post(`${apiUrl}/growth-phases`, { ...data, variety: { id: varietyId } }, { headers: getAuthHeaders() });
    return response.data;
};

export const updateGrowthPhase = async (phaseId, varietyId, data) => {
    const response = await axios.put(`${apiUrl}/growth-phases/${phaseId}`, { ...data, variety: { id: varietyId } }, { headers: getAuthHeaders() });
    return response.data;
};

export const deleteGrowthPhase = async (phaseId) => {
    const response = await axios.delete(`${apiUrl}/growth-phases/${phaseId}`, { headers: getAuthHeaders() });
    return response.data;
};
